<div class="header">
  <div class="title">
    <span class="text">{{ title }}</span>
    <ng-content select="[actions]"></ng-content>
  </div>
  <div class="description" *ngIf="!!description">{{ description }}</div>
</div>
<div class="content">
  <ng-content select="[content]"></ng-content>
</div>
